import React from 'react';
import styles from './ProjectedORTable.module.css';

const getColumnColor = (value) => {
  if (value < 80) return styles.textRed;
  if (value < 95) return styles.textYellow;
  return styles.textGreen;
};

const getColorBasedOnType = (value1, value2) => {
  if (value1) return styles.textBlue;
  if (value2) return styles.textYellowAccent;
  return '';
};

export default function ProjectedORTable({ data, isOn }) {
  return (
    <div className={`${styles.wrapper} no-scrollbar`}>
      <div className={styles.headerColumn}>
        <div className={`${styles.headerCell} `} />
        {isOn ? (
          <div className={`${styles.headerCell} `}>OR</div>
        ) : (
          <>
            <div className={styles.headerCell}>Plan</div>
            <div className={styles.headerCell}>Actual /<br />Projected</div>
          </>
        )}
      </div>

      {data.map((item, index) => (
        <div key={index} className={styles.dataColumn}>
          {item.isCurrent && (
            <>
              <div className={styles.activeDotWrapper}>
                <div className={styles.activeDot}></div>
              </div>
              <div className={styles.activeOverlay}></div>
            </>
          )}

          <div className={`${styles.dayCell}`}>
            {item.day}
          </div>

          {isOn ? (
            <div className={`${styles.dataCell} ${styles.fullHeight}`}>
              <span className={`${styles.text} ${getColumnColor(Number(item.abs))}`}>
                {item.abs}
              </span>
            </div>
          ) : (
            <>
              <div className={styles.dataCell}>
                <span className={`${styles.text} ${styles.textMuted}`}>
                  {item.plan}
                </span>
              </div>
              <div className={styles.dataCell}>
                <span className={`${styles.text} ${getColorBasedOnType(Number(item.projected), Number(item.actual))}`}>
                  {item.projected || item.actual}
                </span>
              </div>
            </>
          )}
        </div>
      ))}
    </div>
  );
}
